/**
 * @param {string} key  chave do local store
 * @returns {any}
 */
export const getLocalStore = (key) => JSON.parse(window.localStorage.getItem(key) || '{}').value

/**
 * @param {string} key chave do local store
 * @param {any} value objeto que será guardado
 * @returns {void}
 */
export const setLocalStore = (key, value) => {
  let objSave = {
    value: value
  }
  window.localStorage.setItem(key, JSON.stringify(objSave))
}

export const defaultValue = 'defaultValue'
/**
 * @param {string} key chave do local store
 * @param {any} obj objeto que será guardado
 * @returns {void | any}
 */
export const setGetLocalStore = (key, obj) => {
  if (obj === defaultValue) return getLocalStore(key) || {}
  setLocalStore(key, obj)
}

const localStoreHelper = {
  viagem: {
    colaborador: (obj = defaultValue) => setGetLocalStore('viagem/colaborador', obj),
    lotesPagos: (obj = defaultValue) => setGetLocalStore('viagem/lotesPagos', obj),
    primeiroAdiantamento: (obj = defaultValue) => setGetLocalStore('viagem/prestacaoContas', obj),
    prestacaoContas: (obj = defaultValue) => setGetLocalStore('viagem/prestacaoContas', obj),
    prestacaoContasDetalhes: (obj = defaultValue) => setGetLocalStore('viagem/prestacaoContasDetalhes', obj)
  },
  controleOcorrencia: {
    contapatologia: (obj = defaultValue) => setGetLocalStore('controleOcorrencia/contapatologia', obj),
    ocorrencias: (obj = defaultValue) => setGetLocalStore('controleOcorrencia/ocorrencias', obj),
    nomeEmpreendimento: (obj = defaultValue) => setGetLocalStore('controleOcorrencia/nomeEmpreendimento', obj),
    relatorio: (obj = defaultValue) => setGetLocalStore('controleOcorrencia/relatorio', obj),
    custoTotal: (obj = defaultValue) => setGetLocalStore('controleOcorrencia/custoTotal', obj)
  },
  reembolsoViagem: {
    adiantamentoPrestacao: (obj = defaultValue) => setGetLocalStore('reembolsoViagem/adiantamentoPrestacao', obj)
  },
  prestacaoContas: {
    adiantamento: (obj = defaultValue) => setGetLocalStore('prestacaoContas/adiantamento', obj),
    descontoFolha: (obj = defaultValue) => setGetLocalStore('prestacaoContas/descontoFolha', obj),
    reembolso: (obj = defaultValue) => setGetLocalStore('prestacaoContas/reembolso', obj),
    viagem: (obj = defaultValue) => setGetLocalStore('prestacaoContas/viagem', obj)
  },
  gestao: {
    credenciada: (obj = defaultValue) => setGetLocalStore('gestao/credenciada', obj),
    tabelaPreco: (obj = defaultValue) => setGetLocalStore('gestao/tabelaPreco', obj),
    empreendimento: (obj = defaultValue) => setGetLocalStore('gestao/empreendimento', obj),
    cliente: (obj = defaultValue) => setGetLocalStore('gestao/cliente', obj),
    documento: (obj = defaultValue) => setGetLocalStore('gestao/documento', obj),
    comunicados: (obj = defaultValue) => setGetLocalStore('gestao/comunicados', obj)
  },
  consulta: {
    vendas: (obj = defaultValue) => setGetLocalStore('consulta/vendas', obj),
    comissao: (obj = defaultValue) => setGetLocalStore('consulta/vendas', obj)
  },
  relatorio: {
    vendasCredenciadas: (obj = defaultValue) => setGetLocalStore('relatorio/vendasCredenciadas', obj)
  },
  solicitacoes: {
    solicitacoes: (obj = defaultValue) => setGetLocalStore('solicitacoes/solicitacoes', obj),
    alteracaoDataParcela: (obj = defaultValue) => setGetLocalStore('solicitacoes/alteracaoDataParcela', obj)
  },
  imobiliaria: {
    consultaVendas: (obj = defaultValue) => setGetLocalStore('imobiliaria/consultaVendas', obj),
    consultaComissoes: (obj = defaultValue) => setGetLocalStore('imobiliaria/consultaComissoes', obj),
    relatorioVendasCorretor: (obj = defaultValue) => setGetLocalStore('imobiliaria/relatorioVendasCorretor', obj)
  }
}

export default localStoreHelper



// WEBPACK FOOTER //
// ./src/shared/utils/localStoreHelper.js